import { Spinner } from '@frontend/components/common';
import React from 'react';

import useScanbotDatacapture from './scanbot-datacapture.controller';

const ID = 'scanbot-datacapture';

export interface WordBox {
    text: string;
    boundingBox: { x: number; y: number; width: number; height: number };
}

export interface ScanbotDatacaptureProps {
    rawTextCallback?: (value: string) => void;
    wordsCallback?: (words: string[]) => void;
    /**
     * ? - any character
     * # - any digit
     * all other characters represent themselves
     */
    pattern?: string;
    /**
     * Show green boxes around detected words that match the pattern
     */
    showGuidanceBoxes?: boolean;
    /**
     * Show user guidance text
     */
    showGuidanceText?: boolean;
    /**
     * Custom guidance text
     */
    guidanceText?: string;
}

export const ScanbotDatacapture = (props: ScanbotDatacaptureProps) => {
    const viewProps = useScanbotDatacapture(props);

    return (
        <div
            id={ID}
            className='h-full w-full'>
            <div className={`relative h-full w-full bg-black`}>
                <div
                    ref={viewProps.divRef}
                    id='scanbot-datacapture-video'
                    style={{ objectFit: 'cover', height: '100%', width: '100%' }}></div>

                {/* SDK initializing overlay */}
                {viewProps.sdkLoading && (
                    <div className='bg-always-black/50 absolute inset-0 flex items-center justify-center'>
                        <Spinner className='text-border-default fill-brand-muted size-8' />
                    </div>
                )}

                {/* Detected Words Overlay */}
                {props.showGuidanceBoxes === true && viewProps.detectedWords.length > 0 && (
                    <div className='pointer-events-none absolute right-0 bottom-0 left-0 flex flex-wrap justify-center gap-1 p-2'>
                        {viewProps.detectedWords.map((word, index) => (
                            <span
                                key={index}
                                className='bg-brand-disabled/80 text-background-surface rounded px-2 py-1 font-mono text-xs'>
                                {word}
                            </span>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
};

export default ScanbotDatacapture;
